import React, { useState } from 'react';

export default function SelectRangeModal({ onClose, onConfirm, initialStart, initialEnd }) {
    const [start, setStart] = useState(() => {
        if (!initialStart) return '';
        const d = new Date(initialStart);
        return d.toISOString().split('T')[0];
    });
    
    const [end, setEnd] = useState(() => {
        if (!initialEnd) return '';
        const d = new Date(initialEnd);
        return d.toISOString().split('T')[0];
    });

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
            <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '16px', width: '320px', display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
                <h3 style={{ fontSize: '18px', fontWeight: 'bold', margin: 0, color: '#1f2937' }}>Select Range</h3>
                
                <div style={{ width: '100%' }}>
                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#e11d48', marginBottom: '8px' }}>Pick Start Date</label>
                    <input 
                        type="date" 
                        value={start} 
                        onChange={e => setStart(e.target.value)}
                        style={{ width: '90%', padding: '10px', borderRadius: '8px', border: '1px solid #e5e7eb', color: '#6b7280', fontSize: '16px', outline: 'none' }} 
                    />
                </div>
                
                <div style={{ width: '100%' }}>
                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '600', color: '#e11d48', marginBottom: '8px' }}>Pick End Date</label>
                    <input 
                        type="date" 
                        value={end} 
                        onChange={e => setEnd(e.target.value)}
                        style={{ width: '90%', padding: '10px', borderRadius: '8px', border: '1px solid #e5e7eb', color: '#6b7280', fontSize: '16px', outline: 'none' }} 
                    />
                </div>

                <button 
                    onClick={() => {
                        if (start && end) {
                            const [sy, sm, sd] = start.split('-');
                            const localStart = new Date(sy, sm - 1, sd);
                            const [ey, em, ed] = end.split('-');
                            const localEnd = new Date(ey, em - 1, ed, 23, 59, 59, 999);
                            onConfirm(localStart, localEnd);
                        }
                    }}
                    style={{ backgroundColor: '#3b82f6', color: 'white', padding: '10px 32px', borderRadius: '24px', border: 'none', fontWeight: 'bold', cursor: 'pointer', marginTop: '8px' }}
                >
                    Ok
                </button>
            </div>
            
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: -1 }} onClick={onClose} />
        </div>
    );
}
